export default "__VITE_ASSET__B8Uzv2IB__"